<script>
// import Constants from '../constants';
import soundPlayer from '@/components/soundPlayer';
import youtubeContainer from '@/components/youtubeContainer';
import vueInstagram from '@/components/vueInstagram';
import vueBandCamp from '@/components/vueBandCamp';
import niconicoContainer from '@/components/niconicoContainer';


export default {
  name: 'album12',
  components: {
    soundPlayer,
    youtubeContainer,
    vueInstagram,
    vueBandCamp,
    niconicoContainer,
  },
  data() {
    return {
      ready: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.ready = true;
    }
  },
};
</script>

<template>
  <div class="uncommon-container" v-if="ready" :class="$mq">

    <div class="contents-container">
      <div class="movie-container">
        <div class="title">{{$t('message.discography.albums.a12.remix')}}</div>
        <youtube-container :file-url="'sE54I1Tg7jM'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="title">{{$t('message.shop.bandcamp')}}</div>
      <div class="contents-bandcamp">
        <vue-band-camp
          embedded-url="https://bandcamp.com/EmbeddedPlayer/album=2460880397/size=large/bgcol=ffffff/linkcol=de270f/tracklist=false/transparent=true/"
          href-url="https://kyousou-gakudan.bandcamp.com/album/alice-corpse"
          :album-title="$t('message.discography.albums.a12.name')"
          />
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <div class="title">{{$t('message.discography.movie')}}</div>
        <youtube-container :file-url="'B6MMRxOwy1Y'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'GD2mVxnskCk'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'-hKLpLzANhQ'"/>
      </div>
    </div>
    
    <div class="contents-container">
      <div class="movie-container">
        <div class="title">{{$t('message.discography.albums.a12.remix')}}</div>
        <niconico-container :file-url="'sm39875510'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="contents-instagram">
        <div class="title">{{$t('message.discography.albums.a12.remix')}}</div>
        <vue-instagram :posts="['CYgMUkYoOPj']" :show-follow-btn="false"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="contents-instagram">
        <vue-instagram :posts="['CHK0Ztwn4Tv']" :show-follow-btn="false"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="movie-container">
        <youtube-container :file-url="'IjgSxyBcLiY'"/>
      </div>
    </div>

    <div class="contents-container">
      <div class="banners-container">
        <div class="title">{{$t('message.discography.specialThanks')}}</div>
        <a class="banner200x40" target="_blank" :title="'白夜の語り部'"
          href="http://studio-lepus.com/"
        >
          <img src="../assets/img/banner/circle/studio-lepus.gif">
        </a>
        <div class="small">{{$t('message.common.jacket')}} 三滝航</div>
      </div>
    </div>
    
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  @import "../css/albumUncommon";
</style>
